import { defineTool } from '@/shell/tool';

/** Hermes: the tailnet host in a frame (Flutter's `hermes` embed). */
export default defineTool({
  id: 'vibes-hermes',
  title: 'Hermes',
  summary: "Hermes, on Tutero's tailnet, in a frame.",
  section: 'agents',
  order: 30,
  icon: 'smart_toy',
  owner: '@Drabu',
  permission: 'vibes-hermes:use',
  routes: () => import('./HermesPage'),
});
